import RecommendedProductsTitle from './RecommendedProductsTitle';
export default RecommendedProductsTitle;
